import { useNavigate } from 'react-router-dom';
import TermsAndConditionsPage from '../components/TermsAndConditionsPage';
import { useAppContext } from '../context/AppContext';
import { ROUTES } from '../navigation';

function TermsPage() {
  const navigate = useNavigate();
  const {
    currentUser,
    userName,
    cartQty,
    handleLogout,
  } = useAppContext();

  return (
    <TermsAndConditionsPage
      onClose={() => navigate(ROUTES.ACCOUNT)}
      user={currentUser}
      userName={userName}
      userPhone={currentUser?.phoneNumber}
      onOpenOrders={() => navigate(ROUTES.ORDERS)}
      onOpenAddresses={() => navigate(ROUTES.ADDRESSES)}
      onOpenCart={() => navigate(ROUTES.CART)}
      cartCount={cartQty}
      onLogout={handleLogout}
      onHelp={() => navigate(ROUTES.HELP)}
    />
  );
}

export default TermsPage;
